import React from 'react';
import {
  Box,
  Container,
  Grid,
  Typography,
  Card,
  CardContent
} from '@mui/material';
import { Star } from '@mui/icons-material';
import getStyles from './styles';

const TenDaysMVPSuccess = () => {
  const styles = getStyles();

  const testimonials = [
    {
      name: 'Priya R.',
      role: 'Small Business Owner',
      content:
        'Amizhth had our website live in 2 days — incredible service! The quality exceeded our expectations and the process was seamless.',
      rating: 5
    },
    {
      name: 'Arjun S.',
      role: 'Startup Founder',
      content:
        'Fast, reliable, and professional. Highly recommend the 10-days launch! They delivered exactly what they promised.',
      rating: 5
    },
    {
      name: 'Maya K.',
      role: 'Freelance Designer',
      content:
        'I was skeptical about the 10-days timeline, but they delivered a beautiful, fully functional website. Amazing team!',
      rating: 5
    }
  ];

  return (
    <Box component="section" sx={styles.section}>
      <Container maxWidth="xl" sx={styles.container}>
        {/* Header */}
        <Box sx={styles.header}>
          <Typography variant="h2" sx={styles.title}>
            Client Success Stories
          </Typography>
          <Typography variant="h3" sx={styles.subtitle}>
            See what our clients say about their experience
          </Typography>
        </Box>

        {/* Testimonials Grid */}
        <Grid container spacing={4} justifyContent="center">
          {testimonials.map((testimonial, index) => (
            <Grid item xs={12} md={4} key={index}>
              <Card
                sx={{
                  ...styles.testimonialCard,
                  animationDelay: `${index * 0.15}s`
                }}
              >
                <CardContent sx={styles.cardContent}>
                  {/* Rating Stars */}
                  <Box sx={styles.ratingContainer}>
                    {[...Array(testimonial.rating)].map((_, i) => (
                      <Star key={i} sx={styles.starIcon} />
                    ))}
                  </Box>

                  {/* Testimonial Text */}
                  <Typography sx={styles.contentText}>
                    “{testimonial.content}”
                  </Typography>

                  {/* Client Info */}
                  <Box sx={styles.clientBox}>
                    <Typography sx={styles.clientName}>
                      {testimonial.name}
                    </Typography>
                    <Typography sx={styles.clientRole}>
                      {testimonial.role}
                    </Typography>
                  </Box>
                </CardContent>
              </Card>
            </Grid>
          ))}
        </Grid>
      </Container>
    </Box>
  );
};

export default TenDaysMVPSuccess;
